// Card brand detection utility functions

export type CardBrand = 'visa' | 'mastercard' | 'discover' | 'amex' | 'diners' | 'jcb' | 'maestro' | 'unknown';

/**
 * Detect card brand from card number
 */
export function detectCardBrand(cardNumber: string): CardBrand {
  // Remove spaces and non-digits
  const cleanNumber = cardNumber.replace(/\D/g, '');
  
  if (cleanNumber.length < 4) {
    return 'unknown';
  }

  // Visa: starts with 4
  if (/^4/.test(cleanNumber)) {
    return 'visa';
  }
  
  // MasterCard: starts with 51-55 or 2221-2720
  if (/^5[1-5]/.test(cleanNumber) || /^222[1-9]|^22[3-9][0-9]|^2[3-6][0-9]{2}|^27[01][0-9]|^2720/.test(cleanNumber)) {
    return 'mastercard';
  }
  
  // Maestro: starts with 5018, 5020, 5038, 5893, 6304, 6759, 6761, 6762, 6763
  if (/^5018|^5020|^5038|^5893|^6304|^6759|^676[1-3]/.test(cleanNumber)) {
    return 'maestro';
  }
  
  // American Express: starts with 34 or 37
  if (/^3[47]/.test(cleanNumber)) {
    return 'amex';
  }
  
  // Discover: starts with 6011, 622126-622925, 644-649, 65
  if (/^6011|^622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[01][0-9]|92[0-5])|^64[4-9]|^65/.test(cleanNumber)) {
    return 'discover';
  }
  
  // DinerClub: starts with 300-305, 36, 38
  if (/^30[0-5]|^36|^38/.test(cleanNumber)) {
    return 'diners';
  }
  
  // JCB: starts with 35 (2131 and 1800 are also JCB but less common)
  if (/^35|^2131|^1800/.test(cleanNumber)) {
    return 'jcb';
  }
  
  return 'unknown';
}

/**
 * Map a detected card brand to one of the 3 routing categories
 */
export function mapBrandToCategory(brand: CardBrand): 'visa' | 'mastercard' | 'other' {
  if (brand === 'visa') return 'visa';
  if (brand === 'mastercard') return 'mastercard';
  return 'other';
}